'use strict';

$('.product-hotspot').hover(function() {
    window.refreshYotpoWidgets?.();
});
